export default class Recommended {
	constructor () {
		this.type = "recommended";
	}
}